import { createFileRoute, useRouter, useSearch } from '@tanstack/react-router';
import { MfaEnrolOrChallenge } from '@/lib/auth/MfaEnrolOrChallenge';
import { resolveSafeNext } from '@/lib/nav/safeNext';

export const Route = createFileRoute('/sign-in/mfa')({
  component: BusinessMfa,
  validateSearch: (search: Record<string, unknown>) => ({
    next: typeof search.next === 'string' ? search.next : undefined,
  }),
});

function BusinessMfa() {
  const router = useRouter();
  const { next } = useSearch({ from: '/sign-in/mfa' });

  return (
    <section className="mx-auto max-w-sm rounded-card border border-border bg-surface p-xl shadow-card">
      <h1 className="text-h2 font-extrabold text-ink">Two-factor authentication</h1>
      <div className="mt-lg">
        <MfaEnrolOrChallenge
          onSuccess={() => {
            // router.history.push takes a plain string, not a
            // route-registry-typed literal — needed here because `next`
            // (the AAL2-gated route that redirected here, e.g. /team) is
            // genuinely dynamic. resolveSafeNext rejects anything but a
            // same-origin relative path (see safeNext.ts).
            router.history.push(resolveSafeNext(next));
          }}
        />
      </div>
    </section>
  );
}
